module.exports = __webpack_public_path__ + "static/media/solo11.0bc3aae5.JPG";